export default __webpack_public_path__ + "static/media/Frame_190.46078dc6.jpg";